import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';
import { usePartnerDividends } from '../context/PartnerDividendsContext';
import DividendsTableRow from './DividendsTableRow';

const DividendsTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerDividends();

  const hasData = data.dividends?.length > 0;

  return (
    <>
      {hasData ? (
        <tbody>
          {data.dividends?.map((dividend: any, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr className="nk-tb-item" key={`dividend-row-${index}`}>
              <DividendsTableRow index={index} dividend={dividend} />
            </tr>
          ))}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('ThisPartnerHasNoDividends')}
          infoMessage=""
          colspan={10}
        />
      )}
    </>
  );
};

export default DividendsTableBody;
